/* src/app/feature-modules/reports/student-reports/student-reports.component.css */
.no-report {
  text-align: center;
  border: dashed 4px rgb(184, 184, 184);
  padding: 14px;
  border-style: dashed;
}
.no-report h3 {
  font-size: 24px;
  color: rgb(184, 184, 184);
}
/*# sourceMappingURL=student-reports.component.css.map */
